import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { RichTextEditor } from './RichTextEditor';
import { AnnouncementCard, ANN_TYPES } from '../LoginAnnouncements';

const EMPTY = { title: '', type: 'info', html: '', start_date: '', end_date: '', is_active: true };

export const AnnouncementFormDialog = ({ open, item, onClose, onSave }) => {
  const [f, setF] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setF({ ...EMPTY, ...(item || {}), start_date: item?.start_date || '', end_date: item?.end_date || '' }); }, [open, item]);
  const set = (p) => setF(prev => ({ ...prev, ...p }));
  const empty = !f.html.replace(/<[^>]*>/g, '').trim();
  const submit = async () => {
    setSaving(true);
    await onSave({ ...f, start_date: f.start_date || null, end_date: f.end_date || null });
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-5xl max-h-[92vh] overflow-y-auto" data-testid="ann-form-dialog">
        <DialogHeader><DialogTitle>{item?.id ? 'Duyuruyu Düzenle' : 'Yeni Duyuru'}</DialogTitle></DialogHeader>
        <div className="grid lg:grid-cols-[1fr_380px] gap-6">
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label>Tür</Label>
              <div className="flex gap-2" data-testid="ann-type">
                {Object.entries(ANN_TYPES).map(([k, t]) => {
                  const I = t.icon;
                  return <button key={k} type="button" onClick={() => set({ type: k })} data-testid={`ann-type-${k}`}
                    className={`flex items-center gap-1.5 rounded-lg border-2 px-3 py-1.5 text-sm font-medium transition-colors ${f.type === k ? `${t.box} ${t.head} border-current` : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}><I className="h-4 w-4" />{t.label}</button>;
                })}
              </div>
            </div>
            <div className="space-y-1.5">
              <Label>Başlık <span className="text-xs font-normal text-slate-400">(isteğe bağlı; boşsa türün adı yazar)</span></Label>
              <Input value={f.title} onChange={(e) => set({ title: e.target.value })} placeholder="ör. Bayram dönemi çalışma izinleri" data-testid="ann-title-input" />
            </div>
            <div className="space-y-1.5">
              <Label>Metin *</Label>
              {open && <RichTextEditor key={item?.id || 'new'} value={f.html} onChange={(html) => set({ html })} />}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5"><Label>Yayın başlangıcı <span className="text-xs font-normal text-slate-400">(boş = hemen)</span></Label><Input type="date" value={f.start_date} onChange={(e) => set({ start_date: e.target.value })} data-testid="ann-start-date" /></div>
              <div className="space-y-1.5"><Label>Yayın bitişi <span className="text-xs font-normal text-slate-400">(boş = süresiz)</span></Label><Input type="date" value={f.end_date} onChange={(e) => set({ end_date: e.target.value })} data-testid="ann-end-date" /></div>
            </div>
            <label className="flex items-center gap-2 text-sm"><Switch checked={f.is_active} onCheckedChange={(v) => set({ is_active: v })} data-testid="ann-active-switch" />Aktif</label>
          </div>
          <div className="space-y-2">
            <Label>Giriş sayfası önizlemesi</Label>
            <div className="rounded-xl bg-slate-50 border p-4 space-y-3" data-testid="ann-preview">
              <div className="rounded-lg bg-white border p-3 space-y-2 opacity-70">
                <div className="h-3 w-24 rounded bg-slate-200" /><div className="h-8 rounded bg-slate-100" /><div className="h-8 rounded bg-slate-100" /><div className="h-8 rounded bg-slate-900" />
              </div>
              {empty ? <p className="text-center text-xs text-slate-400 py-4">Metin yazdıkça burada görünür</p> : <AnnouncementCard a={f} />}
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="ann-cancel-btn">Vazgeç</Button>
          <Button onClick={submit} disabled={empty || saving} data-testid="ann-save-btn">Kaydet</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
